export const enum ResponseValueType {
  FREEBET = 'FreeBet',
  DEPOSIT = 'Deposit',
}

export type PromoValues = {
  code: string;
};

export type PromocodeDataFromBackend = {
  type: ResponseValueType;
};
